import clsx from 'clsx';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { usePDPData, usePDPStatus } from '~/features/product-details/context';
import { VariantOption } from '~/features/product-details/types';
import { ProductVariantSelector } from './ProductVariantSelector';
import styles from './ProductVariants.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    onVariantClick(option: VariantOption, event: React.MouseEvent<HTMLElement>): void;
}

export const ProductVariants: React.FC<Props> = ({ className, onVariantClick, ...rest }) => {
    const { variantGroups } = usePDPData();
    const { isProductDataLoading, selectedProductId } = usePDPStatus();

    if (!variantGroups.length) return null;

    return (
        <div className={clsx(styles.variants, className)} {...rest}>
            {variantGroups.map((group) => (
                <ProductVariantSelector
                    key={group.id}
                    group={group}
                    isLoading={isProductDataLoading}
                    selectedProductId={selectedProductId}
                    onVariantClick={onVariantClick}
                />
            ))}

            {/* Container for showing unavailable product variants warning. */}
            <ToastContainer
                containerId="product-variants-toast"
                className={styles.toastContainer}
                enableMultiContainer
            />
        </div>
    );
};
